'use client';
import { jsxs as t, Fragment as s, jsx as e } from "react/jsx-runtime";
import { Icon as i } from "@tameeni/icons";
import { useInheritDocDirection as c, cn as h } from "@tameeni/shared-logic";
const d = ({ isNav: n, href: o, isFooter: r, locale: a }) => {
  const { direction: m } = c({ locale: a });
  return /* @__PURE__ */ t(s, { children: [
    !r && /* @__PURE__ */ e("a", { href: o, className: "sm:hidden", children: /* @__PURE__ */ e(
      i,
      {
        width: "30",
        height: "30",
        name: "TameeniLogoIcon",
        className: "w-[30px] h-[30px] text-primary"
      }
    ) }),
    /* @__PURE__ */ e("a", { href: o, className: "max-sm:hidden", children: /* @__PURE__ */ e(
      i,
      {
        height: "36",
        name: m === "rtl" ? "TameeniLogoAR" : "TameeniLogoEN",
        className: h(
          "h-[36px]",
          n && "ml-4",
          m === "rtl" ? "w-[113px]" : "w-[165px]"
        )
      }
    ) })
  ] });
};
export {
  d as HomeLogo
};
//# sourceMappingURL=home-logo.js.map
